<div class="affiliates-tiers-modal--header">
  <h2 class="affiliates-tiers-modal--title">Affiliate tiers</h2>
  <p class="affiliates-tiers-modal--description">
    Level up to boost your comission rate with your affiliates
  </p>
</div>
<div class="affiliates-tiers-modal--cards">
  @if (affiliatesService.tiersResource.isLoading()) {
  <div class="affiliates-tier-card--skeleton skeleton-animation"></div>
  <div class="affiliates-tier-card--skeleton skeleton-animation"></div>
  <div class="affiliates-tier-card--skeleton skeleton-animation"></div>
  <div class="affiliates-tier-card--skeleton skeleton-animation"></div>
  <div class="affiliates-tier-card--skeleton skeleton-animation"></div>
  <div class="affiliates-tier-card--skeleton skeleton-animation"></div>
  }
  @if (affiliatesService.tiersResource.hasValue() &&
  !affiliatesService.tiersResource.error()) { @for (tier of
  affiliatesService.tiersResource.value() | keyvalue; track tier.key) {
  <app-affiliates-tier-card
    animate.enter="animate-fade-in"
    [tier]="tier.value"
    [isActive]="tier.key === activeTierKey()"
  ></app-affiliates-tier-card>
  } } @if (affiliatesService.tiersResource.error()) {
  <div
    style="text-align: center"
    class="flex flex-col gap-4 items-center justify-center w-full h-full"
  >
    {{ affiliatesService.tiersResource.error() }}
    <button
      class="button button--style-primary h-32 padding-x-12 rounded-4"
      (click)="affiliatesService.tiersResource.reload()"
    >
      Reload
    </button>
  </div>
  }
</div>
